import React from 'react'
import { AlertList, PanelTitle } from './InventoryShared';

function LowStockAlertPage({ items }) {
    return (
        <section className='inventory-panel inventory-table-panel full'>
            <PanelTitle title='Low Stock Alert Section' />
            <AlertList items={items.filter(item => item.currentStock <= item.threshold)} />
        </section>
    );
}

export default LowStockAlertPage
